import {
  faShieldBlank,
  faUnlockKeyhole,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function Policies() {
  return (
    // Access id from url and scroll to that section or open that section.
    <div className="mt-10">
      <div className="container">
        <h1
          id="terms&conditions"
          className="text-center text-3xl pb-2 font-semibold text-ambhosOrange"
        >
          Terms and Conditions
        </h1>
        <hr />
      </div>
    </div>
  );
}
